export class XEmbedListener {
    public static bindScriptLoad(target: HTMLScriptElement, handler: () => void): void {
        target.addEventListener("load", handler, { once: true });
    }

    public static bindScriptError(target: HTMLScriptElement, handler: () => void): void {
        target.addEventListener("error", handler, { once: true });
    }
}
